import React from "react";
import { Link } from "react-router-dom";

const StatisticsSection = () => {
  return (
    <section className="statistics-section bg-gradient-to-br from-custom-pink via-purple-800 to-indigo-900 py-16 sm:py-20 lg:py-24 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-net-pattern"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold via-yellow-400 to-gold"></div>
      <div className="absolute bottom-0 right-0 w-32 h-32 bg-gold opacity-20 rounded-full transform translate-x-16 translate-y-16"></div>
      <div className="absolute top-1/4 left-0 w-24 h-24 bg-white opacity-10 rounded-full transform -translate-x-12"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
            Choose Your
            <span className="block text-gold">Success Path</span>
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Transform your future with our comprehensive programs designed for
            career excellence
          </p>
        </div>

        {/* Program Cards */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {/* Short Courses Card */}
          <div className="group relative">
            <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-2xl transform group-hover:scale-105 transition-all duration-300 border-l-4 border-gold">
              {/* Icon */}
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-gold to-yellow-500 rounded-full mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>

              <h3 className="text-3xl lg:text-4xl font-bold text-custom-pink mb-4 text-center">
                Short Courses
              </h3>

              <div className="space-y-4 mb-8">
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-gold mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Computer Applications</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-gold mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Graphics Design</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-gold mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">
                    Web Design & Development
                  </span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-gold mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">
                    Languages & Communication
                  </span>
                </div>
              </div>

              <div className="text-center">
                <Link
                  to="/course/short-courses"
                  className="inline-block bg-gradient-to-r from-gold to-yellow-500 text-white px-8 py-3 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  Start Learning Today
                </Link>
              </div>
            </div>
          </div>

          {/* Diploma Courses Card */}
          <div className="group relative">
            <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-2xl transform group-hover:scale-105 transition-all duration-300 border-l-4 border-custom-pink">
              {/* Icon */}
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-custom-pink to-purple-600 rounded-full mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>

              <h3 className="text-3xl lg:text-4xl font-bold text-custom-pink mb-4 text-center">
                Diploma Courses
              </h3>

              <div className="space-y-4 mb-8">
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-custom-pink mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Information Technology</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-custom-pink mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Cybersecurity</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-custom-pink mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Business Administration</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-custom-pink mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">
                    Travel & Tourism Management
                  </span>
                </div>
              </div>

              <div className="text-center">
                <Link
                  to="/admissions"
                  className="inline-block bg-gradient-to-r from-custom-pink to-purple-600 text-white px-8 py-3 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  Enroll Now
                </Link>
              </div>
            </div>
          </div>

          {/* Online Courses Card (centered below on md screens) */}
          <div className="md:col-span-2 flex justify-center">
            <div className="group relative bg-white rounded-2xl p-8 lg:p-10 shadow-2xl transform group-hover:scale-105 transition-all duration-300 border-l-4 border-indigo-500 w-full max-w-2xl">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-full mb-6 mx-auto group-hover:rotate-12 transition-transform duration-300">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 14l9-5-9-5-9 5 9 5z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 14l6.16-3.422A12.083 12.083 0 0112 21.5 12.083 12.083 0 015.84 10.578L12 14z"
                  />
                </svg>
              </div>
              <h3 className="text-3xl lg:text-4xl font-bold text-custom-pink mb-4 text-center">
                Online Courses
              </h3>
              <div className="space-y-4 mb-8">
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-indigo-500 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Flexible schedules</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-indigo-500 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">
                    Industry-recognized certificates
                  </span>
                </div>
                <div className="flex items-center text-gray-700">
                  <svg
                    className="w-5 h-5 text-indigo-500 mr-3 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-semibold">Learn anywhere, anytime</span>
                </div>
              </div>
              <div className="text-center">
                <a
                  href="https://jriit.vedubox.net/pages/login"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block bg-gradient-to-r from-indigo-500 to-blue-600 text-white px-8 py-3 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  Explore Online
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-white text-lg mb-6">
            Join thousands of successful graduates who chose JR Institute for
            their professional journey
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-200">
            <span className="flex items-center">
              <svg
                className="w-4 h-4 text-gold mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              NACTE Accredited
            </span>
            <span className="flex items-center">
              <svg
                className="w-4 h-4 text-gold mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              Industry Partnerships
            </span>
            <span className="flex items-center">
              <svg
                className="w-4 h-4 text-gold mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              Expert Faculty
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
